<template>
    <div v-if="open" class="admin-dialog-overlay" @click.self="onBackdrop">
        <div
            class="admin-dialog admin-dialog--relative"
            :class="{ 'admin-dialog--wide': wide }"
            role="dialog"
            :aria-labelledby="titleId"
        >
            <button
                v-if="showClose"
                type="button"
                class="admin-dialog__close"
                aria-label="Chiudi"
                @click="close"
            >
                <i class="fa fa-times" aria-hidden="true" />
            </button>
            <h2 :id="titleId" class="admin-dialog__title">{{ title }}</h2>
            <p v-if="help" class="admin-dialog__help">{{ help }}</p>
            <slot />
            <div v-if="$slots.actions" class="admin-dialog__actions">
                <slot name="actions" />
            </div>
        </div>
    </div>
</template>

<script>
let titleCounter = 0;

export default {
    name: 'AdminDialog',
    props: {
        open: { type: Boolean, default: false },
        title: { type: String, default: '' },
        help: { type: String, default: '' },
        wide: { type: Boolean, default: false },
        showClose: { type: Boolean, default: false },
        closeOnBackdrop: { type: Boolean, default: true },
    },
    emits: ['update:open', 'close'],
    data() {
        titleCounter += 1;

        return {
            titleId: `admin-dialog-title-${titleCounter}`,
        };
    },
    methods: {
        close() {
            this.$emit('update:open', false);
            this.$emit('close');
        },
        onBackdrop() {
            if (this.closeOnBackdrop) {
                this.close();
            }
        },
    },
};
</script>
